import { classes, DOM } from '../const';

const { isIE, isFixed, isAbsolute } = classes;
const { $window } = DOM;

const ie = () => {
    if (!document.documentMode) return;

    $('body').addClass(isIE);

    const $$stickyContainers = $('.js-sticky');

    $window.scroll(() => {
        $('.js-sticky-bg').each((i, el) => {
            const $parent = $(el).parent();

            if ($parent.offset().top + $parent.outerHeight() < $window.scrollTop()) {
                $(el).hide();
            } else {
                $(el).show();
            }

        });
    });

    $$stickyContainers.each((i, el) => {
        const $parent = $(el).parent();
        const $right = $parent.find('.js-sticky-right');


        const checkSticky = () => {
            const windowTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            const parentTop = $parent.offset().top;
            const parentHeight = $parent.outerHeight();

            const conditionTop = windowTop >= parentTop;
            const conditionBottom = windowTop + windowHeight <= parentTop + parentHeight;

            if (conditionTop && conditionBottom) {
                $(el).removeClass(isAbsolute);
                $(el).addClass(isFixed);
                $(el).removeAttr('style');
                $(el).width($parent.width() - $right.width());
            } else {
                $(el).removeClass(`${isFixed} ${isAbsolute}`);
                $(el).removeAttr('style');
            }

            if (conditionTop && !conditionBottom) {

                $(el).css({
                    top: $parent.outerHeight() - $(el).outerHeight() - 30,
                    width: $parent.width() - $right.width()
                })
                $(el).addClass(isAbsolute);
            }
        };




        checkSticky();
        $window.scroll(checkSticky);

    });

};

export default ie;
